import { Button } from '@radix-ui/themes'
import { useAppDispatch } from '../../reducers/store'
import { checkIfOrgHasDemoData, removeDemoData, setCurrentPage } from '../../reducers/settings'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

function DemoDataSettings() {
  const dispatch = useDispatch()
  const di = useAppDispatch()

  const removeDemoDataForOrg = async () => {
    const hasBeenRemoved = await di(removeDemoData())

    if (hasBeenRemoved) {
      di(checkIfOrgHasDemoData())
      localStorage.setItem('SETTINGS_PAGE_COOKIE', 'SSO')
      dispatch(setCurrentPage('SSO'))
      toast.success('Demo data removed successfully', DEFAULT_TOAST_CONFIG)
    } else {
      toast.error('An error occurred while removing demo data', DEFAULT_TOAST_CONFIG)
    }
  }

  return (
    <>
      <div className="w-full h-full mt-6">
        <>
          <p>
            Remove the demo data from your portal? Removing the demo data cannot be undone and will reset your
            organization's dashboard stats.
          </p>
          <Button className="bg-ErrorRed mt-4 w-[500px] cursor-pointer" onClick={() => removeDemoDataForOrg()}>
            Remove Demo Data
          </Button>
        </>
      </div>
    </>
  )
}

export default DemoDataSettings
